import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./MultiItemCarousel.css";
import { multiData } from "./data";

const carouselProperties = {
  slidesToShow: 3,
  centerMode: true,
  centerPadding: "170px",
  autoplay: true,           // Enable autoplay
  autoplaySpeed: 3000,      // Set autoplay speed (3 seconds)
  infinite: true,           // Ensure infinite loop
  cssEase: "linear",        // Make the transitions smooth
  speed: 1000,              // Set the transition speed for a smoother effect (1 second)
  draggable: false,         // Disable dragging
  arrows: false,            // Hide arrows for seamless transition
  pauseOnHover: false,      // Prevent pausing on hover for uninterrupted flow
  responsive: [
    {
      breakpoint: 426,
      settings: {
        slidesToShow: 1,
        centerMode: false,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 3,
        centerMode: false,
      },
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 4,
        centerMode: false,
        slidesToScroll: 2,
      },
    },
  ],
};

const MultiItemCarousel = () => {
  return (
    <section id="MultiItemCarousel" className="carousel-section">
      <div className="carousel-text">
        <h1>Sponsors and Partners</h1>
        <p>
          {/* Strategy Development, Implementation and Integration Strategy is the
          scope of an organisation over the long-term: which achieves advantage
          for the organisation through its configuration of resources to fulfil
          stakeholder expectations. */}
        </p>
        <Slider {...carouselProperties}>
          {multiData.map((item, index) => (
            <Card key={index} item={item} />
          ))}
        </Slider>
      </div>
    </section>
  );
};

const Card = ({ item }) => {
  return (
    <div className="carousel-card" style={{ textAlign: "center" }}>
      <img
        className="multi__image"
        src={item}
        alt="partner-logo"
        style={{
          width: "100%",
          height: "170px",
          objectFit: "contain",
          marginBottom: "10px",
        }}
      />
    </div>
  );
};

export default MultiItemCarousel;
